import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllCandidates = (limit, lastTime, callback) => {
  return async (dispatch) => {
    if (lastTime) {
      dispatch({
        type: 'GETTING_ALL_CANDIDATES_WITH_PAGINATION',
      });
    } else {
      dispatch({ type: 'GETTING_ALL_CANDIDATES' });
    }
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/users`, {
            params: {
              'request-id': reqId,
              limit: limit,
              lastSeen: lastTime,
              role: 'candidate',
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            if (lastTime) {
              await dispatch({
                type: 'ADD_CANDIDATES_TO_ALL_CANDIDATES',
                payload: {
                  candidates: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            } else {
              await dispatch({
                type: 'GETTING_ALL_CANDIDATES_DONE',
                payload: {
                  candidates: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            }
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_ALL_CANDIDATES_FAILED',
              payload: `Failed to fetch candidates`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_ALL_CANDIDATES_FAILED',
            payload: `Failed to fetch candidates`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_ALL_CANDIDATES_FAILED',
        payload: `Failed to fetch candidates`,
      });
    }
  };
};

export default getAllCandidates;
